export default "__VITE_ASSET__7TnV4S4b__"